import { ExpandMore } from '@mui/icons-material';
import { PmiButton } from 'shell/components/shared/button';
import { Accordion, Typography, Grid, AccordionDetails, useEventCallback } from '@mui/material';
import { FormikProps } from 'formik';
import React, { memo, useMemo, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { BatchDownloadFileFilters } from 'system/pages/batch-management/file-managment/download/list/types';
import SearchBatchList from 'system/components/shared/search-batch-list';
import { SearchField } from 'system/components/shared/search-batch-list/constants';
import { JobVM } from 'system/view-models/batch-managment/job-vm';
import { toast } from 'react-toastify';
interface BatchDownloadFilesFiltersProps {
  downloadFileForm: FormikProps<BatchDownloadFileFilters>;
}
const BatchDownloadFileFiltersComponent = ({
  downloadFileForm,
}: BatchDownloadFilesFiltersProps): React.ReactElement => {
  const [open, setOpen] = useState<boolean>(true);

  const throwJobErrorAndResetSelection = useEventCallback((job: JobVM) => {
    toast.error(`Il batch ${job?.name} ricercato non produce output`);
    downloadFileForm.setValues({
      ...downloadFileForm.values,
      batchName: null,
      batchDescription: null,
    });
  });

  const isSearchDisabled = useMemo(() => {
    return Boolean(
      (downloadFileForm.values?.batchName && !downloadFileForm.values?.batchName?.outputFolder) ||
        (downloadFileForm.values?.batchDescription &&
          !downloadFileForm.values?.batchDescription?.outputFolder)
    );
  }, [downloadFileForm.values?.batchName, downloadFileForm.values?.batchDescription]);

  return (
    <>
      <Accordion
        expanded={open}
        onChange={() => {
          setOpen(!open);
        }}
      >
        <AccordionSummary
          aria-controls="panel-batch-content"
          id="panel-batch-header"
          classes={{
            root: 'pmi-flex-row-reverse',
          }}
          expandIcon={<ExpandMore />}
        >
          <Typography>Filtri</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <form onSubmit={downloadFileForm.handleSubmit}>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} md={4}>
                <SearchBatchList
                  searchField={SearchField.JOB_NAME}
                  value={downloadFileForm.values?.batchName || null}
                  error={
                    downloadFileForm.touched.batchName && Boolean(downloadFileForm.errors.batchName)
                  }
                  helperText={downloadFileForm.errors?.batchName}
                  onChange={(item: JobVM | null) => {
                    if (item && !item.outputFolder) {
                      throwJobErrorAndResetSelection(item);
                      return;
                    }
                    downloadFileForm.setValues({
                      ...downloadFileForm.values,
                      batchName: item,
                      batchDescription: null,
                      folderName: item?.outputFolder || '',
                    });
                  }}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <SearchBatchList
                  searchField={SearchField.JOB_DESCRIPTION}
                  value={downloadFileForm.values?.batchDescription || null}
                  error={
                    downloadFileForm.touched.batchDescription &&
                    Boolean(downloadFileForm.errors.batchDescription)
                  }
                  helperText={downloadFileForm.errors?.batchDescription}
                  onChange={(item: JobVM | null) => {
                    if (item && !item.outputFolder) {
                      throwJobErrorAndResetSelection(item);
                      return;
                    }
                    downloadFileForm.setValues({
                      ...downloadFileForm.values,
                      batchDescription: item,
                      batchName: null,
                      folderName: item?.outputFolder || '',
                    });
                  }}
                />
              </Grid>
              <Grid item xs>
                <PmiButton
                  disabled={isSearchDisabled}
                  variant="contained"
                  color="secondary"
                  type="submit"
                >
                  Cerca
                </PmiButton>
              </Grid>
            </Grid>
          </form>
        </AccordionDetails>
      </Accordion>
    </>
  );
};

BatchDownloadFileFiltersComponent.displayName = 'Batch download file filters component';
const DownloadFileFormComponent = memo(BatchDownloadFileFiltersComponent);
export default DownloadFileFormComponent;
